import React from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

import i18n from '../../i18n';
import Login from '../../pages/Pages/Login/Login';

import { getRouterPath } from './routesHandler';
moment.locale('en');

export const routes = (currentUser) => {
    let lang = currentUser === null ? 'en' : currentUser.language;

    const promise = i18n.changeLanguage(lang).then(() => {
        return getRouterPath(currentUser, i18n);
    });
    return promise;
};

export const loginRoutes = [
    {
        path: '/login',
        exact: true,
        component: Login
    },
    {
        component: () => <Redirect to="/login" />
    }
];
